export default (store_id, token, number) => {

  const comment_area = document.getElementById('comment_area')

  const xhr = new XMLHttpRequest()
  xhr.open('GET', '/api/v1/store_comments/' + store_id + '?number=' + number)
  xhr.setRequestHeader( 'X-CSRF-Token', token)
  xhr.setRequestHeader('Content-Type', 'application/json');
  xhr.send()
  xhr.addEventListener('load', function(result) {
    if (result.currentTarget.status == 200) {
      while(comment_area.firstChild) {
        comment_area.removeChild(comment_area.firstChild);
      }

      if (result.currentTarget.responseText.length == 0) {
          return
      }
      const json = JSON.parse(result.currentTarget.responseText)
      for(let comment of json) {

        const commentMeta = document.createElement('div')
        commentMeta.className = 'comment-meta'

        const symbol = document.createElement('div')
        symbol.innerHTML = '<i class="material-icons">person</i>'
        symbol.className = 'comment-symbol'

        const commentMetaInner = document.createElement('div')
        commentMetaInner.className = 'comment-meta-inner'

        const staff_name = document.createElement('div')
        staff_name.innerText = comment.staff_name
        staff_name.className = 'comment-name'

        const time_info = document.createElement('div')
        time_info.innerText = comment.time_info
        time_info.className = 'comment-time'

        commentMetaInner.append(staff_name)
        commentMetaInner.append(time_info)

        commentMeta.appendChild(symbol)
        commentMeta.appendChild(commentMetaInner)

        const message = document.createElement('div')
        message.innerText = comment.comment_message
        message.className = 'comment-message'

        const comment_div = document.createElement('div')
        comment_div.className = 'comment-div'
        comment_div.appendChild(commentMeta)
        comment_div.appendChild(message)

        comment_area.appendChild(comment_div)
      }
    } else {
      alert(result.currentTarget.responseText)
    }
  })
}
